import { Component, OnInit } from '@angular/core';
import { ListComponent } from '../list.component';
import { User } from '../../../shared/models/user.interface';
import { finalize } from 'rxjs/operators';
import { settings } from '../../../shared/constants/settings';

@Component({
  selector: 'app-list-mobile',
  templateUrl: './list-mobile.component.html',
  styleUrls: ['./list-mobile.component.scss']
})
export class MobileListComponent extends ListComponent implements OnInit { 
  salesPerson: User;

  page: number = 0;
  moreData: boolean = true;

  ngOnInit() {
    super.init();
    this.filter.showInactive = false;

    this.loadCustomers();
  }

  loadCustomers() {
    this.page = 0;
    this.moreData = true;
    this.customers = [];

    this.appendCustomers();     
  }

  appendCustomers() {
    if (!this.moreData) return;

    this.customerService.getList(this.filter, 'customerName', 'asc', this.page)
      .subscribe({
        next: (data) => {
          this.moreData = (data.length == settings.pageSize);
          data.forEach(d => this.customers.push(d));
        },
        error: (error: string) => this.onError(error)
      });
  }

  onScroll() {
    this.page++;

    this.appendCustomers();
  }
}
